import mutations from '../store/mutations'

export default {




    state: {

        commandResponse: {
            selected: {
                type: null,
                id: null,
            },
            types: {
                text: {
                    has_options: false,
                },
                static_cards: {
                    has_options: false,
                },
                quick_rep: {
                    has_options: false,
                },
                api: {
                    has_options: true
                },
                dataset: {
                    has_options: true
                },
                datasource: {
                    has_options: true
                },
                menu: {
                    has_options: true
                },
                shopping_cart: {
                    has_options: true
                },
                component: {
                    has_options: true
                },
                location: {
                    has_options: false
                }
            }
        },





        go_services: [],
        go_services_id: 0,
        go_commands: [],
        go_commands_id: 0,
        go_variables: [],
        go_variables_id: 0,
        breadcrumb_history: {},
        autocomplete: {
            '@f': {
                icon: 'fa-cubes',
                list: ['current_date'],
                short_descroption: 'Functions',
            },
        },
        menuAutocomplete: {
            '@m': {
                icon: 'fa-cubes',
                list: ['title', 'subtitle', 'price', 'image'],
                short_descroption: 'Item Fields',
            },
        },
        sender_info: {
            '-1': 'sender_id',
            '-2': 'sender_full_name',
            '-3': 'sender_platform',
            '-5': 'sender_username',
            '-4': 'sender_message',
        },
        user: {
            is_login: false,
            user_id: null,
            user_reg_driver: null,
            username: '',
            avatar: null,
            user_email: null,
            fb_pages: [],
        },
        messenger_init: false,
        sql_support_drivers: [{
            label: 'MS SQL Server',
            value: 'MS_SQL_SERVER',
        }, {
            label: 'MySQL',
            value: 'MY_SQL',
        }, {
            label: 'Oracle',
            value: 'ORACLE',
            disabled: 1,
        }, {
            label: 'PostgreSQL',
            value: 'POSTGRE_SQL',
        }, {
            label: 'SQLite',
            value: 'SQLITE',
            disabled: true,
        },],
        speech_cloud: {
            types: [{
                label: 'Google Cloud Speech',
                value: 'GOOGLE_CLOUD_SPEECH',
            }, {
                label: 'Microsoft Cloud Speech',
                value: 'MICROSOFT_CLOUD_SPEECH',
                disabled: 1,
            },],
            lang_default: 'ar-EG',
            langs: [{
                label: 'العربيه',
                value: 'ar-EG',
            }, {
                label: 'English',
                value: 'en-US',
            },],
        },
        cm_base_options: {
            indentWithTabs: true,
            smartIndent: true,
            lineNumbers: true,
            line: true,
            matchBrackets: true,
            autofocus: false,
            styleSelectedText: true,
            autoCloseBrackets: true,
            lineWrapping: true,
            extraKeys: {
                'Ctrl-Space': 'autocomplete',
            },
            readOnly: false,
            hintOptions: {
                tables: {
                    users: ['name', 'score', 'birthDate'],
                    countries: ['name', 'population', 'size'],
                },
            },
        },

        follow: {
            originalData: {},
            copyData: {},
            hasChange: function () {
                var hasDeference = function (o, c) {
                    var s = Object.prototype.toString
                    var t = s
                        .call(o)
                        .replace(/\[object|\s|\]/g, '')
                        .toLowerCase()
                    switch (t) {
                        case 'string':
                            return !(o === c)
                        case 'boolean':
                            return !(!!o === !!c)
                        case 'number':
                            return !(parseInt(o) === parseInt(c))
                        case 'object':
                            return checkDifference(o, c, Object.keys(o))
                        case 'array':
                            return recursiveDifference(o.slice(), c.slice())
                        default:
                            return false
                    }
                }
                var recursiveDifference = function (oArr, cArr) {
                    if (!oArr.length) {
                        return false
                    }
                    var fO = oArr.splice(0, 1)[0]
                    var fC = cArr.splice(0, 1)[0]
                    return !hasDeference(fO, fC) ? recursiveDifference(oArr, cArr) : true
                }
                var checkDifference = function (o, c, ks) {
                    if (!ks.length) {
                        return false
                    }
                    var k = ks.splice(0, 1)[0]
                    if (o[k] && c[k]) {
                        return !hasDeference(o[k], c[k]) ? checkDifference(o, c, ks) : true
                    }
                    return false
                }

                return checkDifference(this.originalData, this.copyData, Object.keys(this.originalData))
            },
        },
        command: {
            response: {
                types: [
                    {
                        label: 'text',
                        value: 'text'
                    },
                    {
                        label: 'Static Cards',
                        value: 'static_cards'
                    },
                    {
                        label: 'Quick Replies',
                        value: 'quick_rep'
                    },
                    {
                        label: 'Location',
                        value: 'location',
                        hide: 0,
                    },
                    {
                        label: 'Subscription',
                        value: 'sub',
                        hide: 1,
                    },
                    {
                        label: 'api',
                        value: 'api'
                    },
                    {
                        label: 'Dataset',
                        value: 'ds'
                    },
                    {
                        label: 'Data source',
                        value: 'data_source'
                    },
                    {
                        label: 'menu',
                        value: 'menu',
                    },
                    {
                        label: 'shopping_cart',
                        value: 'shopping_cart',
                    },
                    {
                        label: 'component',
                        value: 'component',
                    },
                    // {
                    //     label: 'navigator',
                    //     value: 'navigator',
                    //     badge: 'new'
                    // },
                ],
                shoppingCartActions: [{
                    label: 'add or update from cart',
                    value: 'insert'
                }, {
                    label: 'delete item(s) from cart',
                    value: 'delete'
                }, {
                    label: 'view_receipt',
                    value: 'view_receipt'
                }],
                dataset: {
                    query: {
                        statements: [
                            {
                                label: '=',
                                value: '='
                            },
                            {
                                label: '!=',
                                value: '!='
                            },
                            {
                                label: '>=',
                                value: '>='
                            },
                            {
                                label: '<=',
                                value: '<='
                            },
                            {
                                label: 'LIKE',
                                value: '%'
                            },
                            {
                                label: 'NEARBY',
                                value: 'nearby',
                            },
                        ],
                        autoCompleteExtraVariables: ['map_url', 'distance']
                    }
                },
                actions: [
                    {
                        label: 'subscribe',
                        value: 'subscribe',
                    },
                    {
                        label: 'Send Mail',
                        value: 'mail',
                    },
                    {
                        label: 'Send api',
                        value: 'api',
                    },
                ],

            },
            variables: {
                types: [
                    {
                        label: 'list',
                        value: 'list'
                    },
                    {
                        label: 'regex',
                        value: 'regex'
                    },
                    {
                        label: 'Search Full Replay',
                        value: 'search'
                    },
                    {
                        label: 'Append From my Dataset',
                        value: 'datasetList'
                    },
                    {
                        label: 'Field at dataset',
                        value: 'search_DS'
                    },
                    {
                        label: 'component',
                        value: 'component'
                    },
                    {
                        label: 'location',
                        value: 'location'
                    },
                ]
            }
        },
        responseData: null
    },
    mutations: mutations,
    getters: {
        get_go_commands_id: (state) => () => state.go_commands_id,
    },
}
